import "@/App.css";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import AppRoutes from "@/AppRoutes";
import { Toaster } from "sonner";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster richColors position="top-right" />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
